<template>
  <div class="business-visa">
    <h1>商务签证Business Visitor Visa</h1>
    <div class="subtitle">访问签证</div>
    
    <div class="content-section">
      <p>是签发给来加从事短期商务活动的外国人的签证。商务活动包括：短期商务考察、洽谈业务、协商签订合同、参加短期商务培训、参加国际会议或展览等。</p>
      
      <h2>适用情况</h2>
      <ul>
        <li>参加商务会议或贸易展览</li>
        <li>与加拿大公司进行业务谈判</li>
        <li>考察投资机会或市场环境</li>
        <li>参加短期商务培训或研讨会</li>
        <li>签订商务合同或协议</li>
        <li>购买加拿大商品或服务</li>
      </ul>

      <h2>申请要求</h2>
      <ul>
        <li>有效护照（有效期至少6个月以上）</li>
        <li>良好的健康状况和无犯罪记录</li>
        <li>有稳定的工作和经济能力</li>
        <li>有明确的商务访问目的</li>
        <li>访问结束后会按时离境</li>
        <li>不会在加拿大从事有报酬的工作</li>
      </ul>

      <h2>所需材料</h2>
      <ul>
        <li>护照原件及复印件</li>
        <li>商务签证申请表</li>
        <li>照片（符合要求的证件照）</li>
        <li>公司营业执照和担保信</li>
        <li>在职证明和收入证明</li>
        <li>商务活动邀请函
          <ul>
            <li>加方公司或机构出具的邀请函</li>
            <li>详细说明访问目的和日程安排</li>
            <li>双方公司的联系信息</li>
          </ul>
        </li>
        <li>行程安排和住宿证明</li>
        <li>往返机票预订单</li>
        <li>资金证明
          <ul>
            <li>银行存款证明</li>
            <li>公司财务报表</li>
            <li>其他资产证明</li>
          </ul>
        </li>
      </ul>

      <h2>注意事项</h2>
      <ul>
        <li>申请材料必须真实完整</li>
        <li>提前规划行程和准备材料</li>
        <li>准确说明访问目的和活动范围</li>
        <li>遵守签证有效期和停留期限</li>
        <li>不得从事未经许可的商业活动</li>
        <li>保持良好的出入境记录</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusinessVisitorVisaView'
}
</script>

<style scoped lang="less">
.business-visa {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }

  .subtitle {
    font-size: 18px;
    color: #666;
    margin-bottom: 30px;
  }

  .content-section {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    p {
      font-size: 16px;
      line-height: 1.6;
      color: #444;
      margin-bottom: 25px;
    }

    h2 {
      font-size: 24px;
      color: #333;
      margin: 30px 0 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid #f0f0f0;
    }

    ul {
      list-style: none;
      padding: 0;
      margin-bottom: 20px;

      li {
        font-size: 16px;
        color: #555;
        margin-bottom: 12px;
        padding-left: 20px;
        position: relative;

        &:before {
          content: "•";
          color: #409EFF;
          position: absolute;
          left: 0;
        }

        ul {
          margin: 10px 0 10px 20px;
        }
      }
    }
  }
}
</style>